import { Avatar } from "@mui/material";
import { root } from "../models/Proxy";
import Title from "./Title";
import { useTenant } from "../models/Hooks";
import { getTheme } from "../theme";

export default function FaviconAvatar({ size }: {size?:number}) {
    const tenant = useTenant();

    if (!size) {
        size = 32;
    }

    return tenant?.Favicon ?
        <Avatar sx={{ width: size, height: size, border: '1px solid ' + getTheme().palette.divider }} src={`${root}files/${tenant.Id}/${tenant.Favicon}`} alt={tenant.Name} /> :
        <Avatar sx={{ width: size, height: size }}><Title /></Avatar>;
}